"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfSignatureStatusDto = instanceOfSignatureStatusDto;
exports.SignatureStatusDtoFromJSON = SignatureStatusDtoFromJSON;
exports.SignatureStatusDtoFromJSONTyped = SignatureStatusDtoFromJSONTyped;
exports.SignatureStatusDtoToJSON = SignatureStatusDtoToJSON;
exports.SignatureStatusDtoToJSONTyped = SignatureStatusDtoToJSONTyped;
/**
 * Check if a given object implements the SignatureStatusDto interface.
 */
function instanceOfSignatureStatusDto(value) {
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('message' in value) || value['message'] === undefined)
        return false;
    return true;
}
function SignatureStatusDtoFromJSON(json) {
    return SignatureStatusDtoFromJSONTyped(json, false);
}
function SignatureStatusDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'status': json['status'],
        'message': json['message'],
        'subMessage': json['subMessage'] == null ? undefined : json['subMessage'],
    };
}
function SignatureStatusDtoToJSON(json) {
    return SignatureStatusDtoToJSONTyped(json, false);
}
function SignatureStatusDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'status': value['status'],
        'message': value['message'],
        'subMessage': value['subMessage'],
    };
}
